import LogoMark from '../Utils/LogoMark';

export default function AgujeroNegro({
  message = 'Agrega cosas antes de que tu negocio se vuelva un caos espacial',
  size = 220,
  logoColor = 'rgba(255, 255, 255, 0.12)',
  cutColor = '#000000',
}) {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{ height: '100%', gap: '24px', padding: '24px' }}
    >
      <LogoMark size={size} logoColor={logoColor} cutColor={cutColor} build={false} />

      <p
        style={{
          fontSize: '13px',
          fontWeight: 500,
          fontFamily: '"Public Sans", sans-serif',
          color: 'rgba(255, 255, 255, 0.4)',
          textAlign: 'center',
          maxWidth: '420px',
          lineHeight: '1.6',
          margin: 0,
        }}
      >
        {message}
      </p>
    </div>
  );
}
